import requirements20261102 from './2026-11-02';
import requirements20261103 from './2026-11-03';

// Venue-search VS1.2. Every version a host ever confirmed stays here, so we
// can show the exact words. Add a version: new file, add it below, point
// CURRENT at it.
export const HOST_REQUIREMENTS = {
  [requirements20261102.version]: requirements20261102,
  [requirements20261103.version]: requirements20261103
};

export const CURRENT_HOST_REQUIREMENTS = requirements20261103;
